import { render, staticRenderFns } from "./ProjectDocumentationView.vue?vue&type=template&id=f1f635ae&scoped=true"
import script from "./ProjectDocumentationView.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentationView.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocumentationView.vue?vue&type=style&index=0&id=f1f635ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f635ae",
  null
  
)

export default component.exports